export { default } from './CollectionDetail';
